const priceMin = 50000;
const priceMax = 1000000;
const areaMin = 0;
const areaMax = 100;
const roomMin = 1;
const roomMax = 10;

const mapStyle = [{"featureType":"administrative","elementType":"all","stylers":[{"saturation":"-100"}]},{"featureType":"administrative.province","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"landscape","elementType":"all","stylers":[{"saturation":-100},{"lightness":65},{"visibility":"on"}]},{"featureType":"poi","elementType":"all","stylers":[{"saturation":-100},{"lightness":"50"},{"visibility":"simplified"}]},{"featureType":"road","elementType":"all","stylers":[{"saturation":"-100"}]},{"featureType":"road.highway","elementType":"all","stylers":[{"visibility":"simplified"}]},{"featureType":"road.arterial","elementType":"all","stylers":[{"lightness":"30"}]},{"featureType":"road.local","elementType":"all","stylers":[{"lightness":"40"}]},{"featureType":"transit","elementType":"all","stylers":[{"saturation":-100},{"visibility":"simplified"}]},{"featureType":"water","elementType":"geometry","stylers":[{"hue":"#ffff00"},{"lightness":-25},{"saturation":-97}]},{"featureType":"water","elementType":"labels","stylers":[{"lightness":-25},{"saturation":-100}]}];

/* ------------------------------------------------------- INITIALIZE APP --- */
whenVendorReady(function() {
  initializePageScript()
});

function initializePageScript() {
  initSwipebox();
  initDescriptionToggle();
  initCalc();
  initOfferMap();
  initGallery();
  initPupupNegotiations();
  initCollapsableDescription();

  $('.checkInstallment').click(function() {
    scrollTo($('.monthlyCost'));
  });

  $('.goToPe').click(function(e) {
    e.preventDefault();
    const url = $(this).attr('href') + '?value=' + $(this).data('value');
    window.open(url, '_blank');
  });
}

function initSwipebox() {
  $('.swipebox').swipebox({
    hideBarsDelay: 0,
    removeBarsOnMobile: false,
    afterOpen: function(){
      var $selectorClose = $("#swipebox-close");
      var clickAction = "touchend click";

      $selectorClose.unbind(clickAction);

      $selectorClose.bind(clickAction, function(event){
        event.preventDefault();
        event.stopPropagation();

        $.swipebox.close();
      });
    }
  });
}


function initDescriptionToggle() {

  $('.showOfferDescription').click(function() {
    if ($(this).hasClass('active')) return;
  
    $('.showOfferDescription').addClass('active');
    $('.offerDescription__main').show();

    $('.showOfferDetails').removeClass('active');
    $('.offerDescription__details').hide();
    scrollTo($('.switchDetailsMode').first());
  });

  $('.showOfferDetails').click(function() {
    if ($(this).hasClass('active')) return;
  
    $('.showOfferDetails').addClass('active');
    $('.offerDescription__details').show();

    $('.showOfferDescription').removeClass('active');
    $('.offerDescription__main').hide();
    scrollTo($('.switchDetailsMode').first());
  });
}

/* --------------------------------------------------------- SLICK SLIDER --- */

/**
 * Initialize gallery
 */
function initGallery() {
  $('.offerGalleryEnlarge').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: '<button class="customSlickArrow--left"><i class="icon-angle-left"></i></button>',
    nextArrow: '<button class="customSlickArrow--right"><i class="icon-angle-right"></i></button>',
    fade: true,
    asNavFor: '.offerGallerySlider'
  });
  $('.offerGallerySlider').slick({
    slidesToShow: 7,
    slidesToScroll: 1,
    asNavFor: '.offerGalleryEnlarge',
    dots: false,
    centerMode: true,
    focusOnSelect: true,
    prevArrow: '<button class="customSlickArrow--left"><i class="icon-angle-left"></i></button>',
    nextArrow: '<button class="customSlickArrow--right"><i class="icon-angle-right"></i></button>',
    responsive: [
      {
        breakpoint: 767,
        settings: 'unslick'
      }
    ]
  });
}


/**
 * Initialize collapsable description
 */
function initCollapsableDescription() {
  const $obj = $('.offerDescription__main');
  const maxHeight = isMobile() ? 1000 : 300;
  const height = $('.offerDescription__main').outerHeight();

  if (height > maxHeight * 1.25) {
    $obj.css('max-height', maxHeight + 'px');
    $obj.addClass('collapsable').addClass('collapsed');
    $obj.append(`
      <button class="offerDescription__toggle btn btn--transparent">
        <i class="icon-down-open"></i>
        <span>Czytaj więcej</span>
      </button>
    `);
    
    $('.offerDescription__toggle').click(function() {
      $obj.removeClass('collapsed');
      $obj.css('max-height', (height + 200) + 'px');
      $(this).fadeOut();
    })
  }
}



/* ------------------------------------------------------------------ MAP --- */

function initOfferMap() {

  var position = {
    lat: Number($('#mapWrapper').data('lat')),
    lng: Number($('#mapWrapper').data('lng'))
  };

  var offerMap = new google.maps.Map(document.getElementById('mapWrapper'), {
    zoom: 15,
    center: position,
    styles: mapStyle
  });

  var cityCircle = new google.maps.Circle({
    strokeColor: '#046b31',
    strokeOpacity: 0.8,
    strokeWeight: 2,
    fillColor: '#109749',
    fillOpacity: 0.35,
    map: offerMap,
    center: position,
    radius: 150
  });
}

/* -------------------------------------------------------- MORTGAGE CALC --- */

function initCalc() {
  initCalcAmount();
  initCalcPeriod();
  updateResult();
  addAmountInputInteractions();
  addPeriodInputInteractions();
}

function initCalcAmount() {
  const val = Number(calcPreset.loanval);
  $('#calcAmount').val(val + ' zł').data('val', val);
  $('#sliderAmount').slider({
    orientation: "horizontal",
    range: 'min',
    min: Number(calcPreset.minval),
    max: Number(calcPreset.maxval),
    value: Number(calcPreset.loanval),
    step: 1000,
    slide: function( event, ui ) {
      $('#calcAmount').val(ui.value + ' zł').data('val', ui.value);
    },
    change: function( event, ui ) {
      calcDelayedUpdate();
    }
  });
}

function initCalcPeriod() {
  const months = Number(calcPreset.months);
  $('#calcPeriod').val(getMonthsLabel(months)).data('val', months);

  $('#sliderPeriod').slider({
    orientation: "horizontal",
    range: 'min',
    min: Number(calcPreset.minmonths),
    max: Number(calcPreset.maxmonths),
    value: Number(calcPreset.months),
    step: 12,
    slide: function( event, ui ) {
      $('#calcPeriod').val(getMonthsLabel(ui.value)).data('val', ui.value);
    },
    change: function( event, ui ) {
      calcDelayedUpdate();
    }
  });
}

function getMonthsLabel(months) {
  return months/12 + ' lat';
}

var calcTimeout = null;
function calcDelayedUpdate() {
  if (calcTimeout !== null) {
    clearTimeout(calcTimeout);
    calcTimeout = null;
  }
  calcTimeout = setTimeout(function() {
    updateResult();
  }, 100);
}

function updateResult() {
  const amount = $('#calcAmount').data('val');
  const period = $('#calcPeriod').data('val');

  $.ajax({
    method: "POST",
    url: "/kalkulator/oblicz-rate",
    data: {
      presetId: 1,
      period: period,
      value: amount
    }
  })
  .done(function(res) {
    $('#calcResult').text(res.result + ' zł');
  });
}

/**
 * Catching events for amount input
 */
function addAmountInputInteractions() {
  $('#calcAmount').click(function() {
    $(this).prop('value', Number(filterDigits($(this).val())));
  });
  $('#calcAmount').keyup(function() {
    var val = Number(filterDigits($(this).val()));
    if (val !== NaN) {
      calcUpdateAmount(val, false);
    }
  });
  $('#calcAmount').change(function() {
    var val = Number(filterDigits($(this).val()));
    if (val !== NaN) {
      calcUpdateAmount(val);
    }
  });
}

/**
 * Catching events for period input
 */
function addPeriodInputInteractions() {
  $('#calcPeriod').click(function() {
    $(this).prop('value', Number(filterDigits($(this).val())));
  });
  $('#calcPeriod').keyup(function() {
    var val = Number(filterDigits($(this).val()));
    if (val !== NaN) {
      calcUpdatePeriod(val, false);
    }
  });
  $('#calcPeriod').change(function() {
    var val = Number(filterDigits($(this).val()));
    if (val !== NaN) {
      calcUpdatePeriod(val);
    }
  });
}

/**
 * Change amount slider and input
 * @param {Number} amount Amount
 * @param {Boolean} refreshInput If false not updating value of input
 */
function calcUpdateAmount(amount, refreshInput) {
  refreshInput = refreshInput !== undefined ? refreshInput : true;
  const max = $('#sliderAmount').slider('option', 'max');
  const min = $('#sliderAmount').slider('option', 'min');
  amount = amount >= min ? amount : min;
  amount = amount <= max ? amount : max;

  $('#sliderAmount').slider('value', amount);
  if (refreshInput) {
    $('#calcAmount').val(amount + ' zł').data('val', amount);
  }
}

/**
 * Change period slider and input
 * @param {Number} period Period in months
 * @param {Boolean} refreshInput If false not updating value of input
 */
function calcUpdatePeriod(period, refreshInput) {
  period = period * 12;
  refreshInput = refreshInput !== undefined ? refreshInput : true;
  const max = $('#sliderPeriod').slider('option', 'max');
  const min = $('#sliderPeriod').slider('option', 'min');
  period = period >= min ? period : min;
  period = period <= max ? period : max;

  $('#sliderPeriod').slider('value', period);
  if (refreshInput) {
    $('#calcPeriod').val(getMonthsLabel(period)).data('val', period);
  }
}

/**
 * Remove all characrers except of digits
 * @param {String} txt String to clear
 */
function filterDigits(txt) {
  return (String(txt)).replace(/\D+/g, '');
}


/* -------------------------------------------------- POPUP NEGOTIATE FORM--- */

/**
 * Initialize pup up negotiation form
 */
function initPupupNegotiations() {

  // $('.negotiationPopup').css('display', 'flex').hide()

  // $('.negotiationPopup__content').click(function(e) {
  //   e.stopPropagation();
  // })

  $('.negotiateBtn').click(function() {
    showPopupNegotiateForm();
  });

  // $('.negotiationPopup, .negotiationPopup__close').click(function() {
  //   hidePopupNegotiateForm();
  // });
}

/**
 * Open negotiation form popup
 */
function showPopupNegotiateForm() {
  $('.negotiationPopup__close').fadeIn();
  $('.negotiationPopup').fadeIn();
}

// /**
//  * Hide negotiation form popup
//  */
// function hidePopupNegotiateForm() {
//   $('.negotiationPopup__close').fadeOut();
//   $('.negotiationPopup').fadeOut();
// }